(() => {
  function initialize() {
    document.querySelectorAll('[data-ln-privacy-open]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', async () => {
        const status = document.querySelector('[data-ln-privacy-status]');
        if (status) { status.hidden = true; status.textContent = ''; }
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        try {
          if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Preferences unavailable');
          await window.privacyBanner.showPreferences();
        } catch {
          if (status) { status.textContent = button.dataset.error; status.hidden = false; }
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
